import _ from 'lodash';
import {getForeignKeyEntityDataType, getPathDetails} from './formattersettingshelpers';

/**
 * Build a specification that filters only the entities of the `entityType` that "fit" on the specified
 * attribute of the `parentDataType`
 * @param parentDataType The entity data type that contains the attribute
 * @param entityType The entity data type that the foreign key points to
 * @param attributeIdOrPath The attribute id (number) or path (string array)
 * @returns {string} A filter specification
 */
const getFkOptionsSpecification = (parentDataType, entityType, attributeIdOrPath) => {
    /** The entity data type that the FK references. */
    const fkDataType = getForeignKeyEntityDataType(entityType);
    if (!fkDataType) {
        throw new Error('Invalid formatter configuration. Expected to be used with a FK or FK array data type.');
    }

    /** The attribute that is being edited. */
    const attribute = getPathDetails(parentDataType, attributeIdOrPath)?.finalAttribute;
    if (!attribute) {
        throw new Error('Invalid formatter configuration. Could not find the specified attribute.');
    }

    /**
     * An additional filter that need to be applied when loading options.
     * This filter is built from the specifications (if any) that are defined
     * for the attribute on the parent data type.
     * @type {string}
     */
    return (
        _(attribute.validationRules)
            .map((rule) => rule.specification)
            // removes empty specifications and non-specification rules
            .filter(_.negate(_.isEmpty))
            .join(' AND ')
    );
};

export {getFkOptionsSpecification};
